(function () {

  const STORAGE_KEY = "wishlist_products";

  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(data) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    updateWishlistCount();
    syncIcons();
  }

  function toggleWishlist(handle) {
    let wishlist = getWishlist();

    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
    } else {
      wishlist.push(handle);
    }

    saveWishlist(wishlist);
  }

  function updateWishlistCount() {
    const countEl = document.querySelector(".wishlist-count");
    if (!countEl) return;
    countEl.textContent = getWishlist().length;
  }

  function syncIcons() {
    const wishlist = getWishlist();

    document.querySelectorAll("[data-wishlist]").forEach(btn => {
      const handle = btn.dataset.wishlist;
      btn.classList.toggle("active", wishlist.includes(handle));
    });
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-wishlist]");
    if (!btn) return;

    e.preventDefault();
    toggleWishlist(btn.dataset.wishlist);
  });

  document.addEventListener("DOMContentLoaded", () => {
    updateWishlistCount();
    syncIcons();
  });

})();

function updateWishlistCount() {
  const wishlist = getWishlist();
  const header = document.querySelector(".wishlist-header");

  if (!header) return;

  if (wishlist.length > 0) {
    header.classList.add("active");
  } else {
    header.classList.remove("active");
  }
}


document.addEventListener("DOMContentLoaded", function () {

  const emptyBox = document.querySelector(".wishlist_empty");
  const grid = document.querySelector(".wishlist-grid");

  if (!emptyBox || !grid) return;

  const handles = JSON.parse(localStorage.getItem("wishlist_products")) || [];

  if (handles.length === 0) {
    emptyBox.style.display = "block";
    grid.style.display = "none";
  } else {
    emptyBox.style.display = "none";
    grid.style.display = "flex";
  }

});


